import ApiService from '@/utils/ApiService'

export default {
  namespaced: true,
  state: {
    agreementsConsents: [],
    item: {
      timelessAgreement: 0,
      agreementItems: [],
      agreementAdditionalItems: [],
      agreementTags: [],
      agreementsConsents: [],
      agreementPromotions: [],
      agreementDevices: [],
      agreementAddresses: [],
      agreementCustomFields: [],
      agreementVariants: [],
      paymentDaysInvoice: 7,
      monthlyInvoice: 0,
      vatInvoice: 1,
      electronicPayments: 1,
      advanceStatus: 0,
      dateFirstPayment: '1970-01-01',
      status: '1',
      paymentFrequency: 1,
      batchNumber: null
    },
    created: false,
    violations: {}
  },
  getters: {
    violations: state => state.violations,
    getAgreementConsents: state => state.agreementsConsents,
    getCreated: state => state.created,
    getItem: state => state.item,
    getItemByIndex: state => index => state.item.agreementItems[index],
    getTotalValueNetto (state, getters, rootState, rootGetters) {
      let totalValueNetto = 0
      state.item.agreementItems.map(entry => {
        try {
          totalValueNetto += rootGetters['agreements/list/getWarehouseItemById'](entry.item).priceNetto
        } catch (e) {}
      })
      return Math.round(totalValueNetto * 100) / 100
    },
    getTotalValueBrutto (state, getters, rootState, rootGetters) {
      let totalValueBrutto = 0
      state.item.agreementItems.map(entry => {
        try {
          totalValueBrutto += rootGetters['agreements/list/getWarehouseItemById'](entry.item).priceBrutto
        } catch (e) {}
      })
      return Math.round(totalValueBrutto * 100) / 100
    },
    getTotalVatAmount (state, getters, rootState, rootGetters) {
      let totalVatAmount = 0
      state.item.agreementItems.map(entry => {
        try {
          let item = rootGetters['agreements/list/getWarehouseItemById'](entry.item)
          totalVatAmount += (item.priceBrutto * item.vatRate.value) / (100 + item.vatRate.value)
        } catch (e) {}
      })
      return Math.round(totalVatAmount * 100) / 100
    }
  },
  mutations: {
    acceptAllConsents (state) {
      state.item.agreementsConsents.forEach(consent => {
        consent.agree = 2
      })
    },
    setCreated (state) {
      state.created = true
    },
    reset (state) {
      state.item = {
        timelessAgreement: 0,
        agreementItems: [],
        agreementAdditionalItems: [],
        agreementTags: [],
        agreementsConsents: [],
        agreementDevices: [],
        agreementAddresses: [],
        agreementCustomFields: [],
        agreementVariants: [],
        paymentDaysInvoice: 7,
        monthlyInvoice: 0,
        vatInvoice: 1,
        electronicPayments: 1,
        advanceStatus: 0,
        dateFirstPayment: '1970-01-01',
        status: '1'
      }
      state.created = false
      state.violations = {}
    },
    acceptSingleConsent (state, payload) {
      state.item.agreementsConsents[payload].agree = 2
    },
    discardSingleConsent (state, payload) {
      state.item.agreementsConsents[payload].agree = 1
    },
    setConsentsForAgreement (state, payload) {
      state.agreementsConsents = payload
      state.agreementsConsents.forEach(entry => {
        entry.agree = 0
      })
    },
    setViolations (state, payload) {
      state.violations = payload
    }
  },
  actions: {
    async fetchConsentsForAgreement ({ commit }, params) {
      let baseParams = { pagination: false, consentType: 0 }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_c_m_consents', baseParams).getResults()
      commit('setConsentsForAgreement', await response.items)
    },
    async create ({ commit }, data) {
      let agreement = JSON.parse(JSON.stringify(data))
      agreement.agreementTags = agreement.agreementTags.map(object => {
        return { tag: object.value }
      })
      agreement.agreementsConsents = agreement.agreementsConsents.map(consent => {
        return { consent: consent.consent['@id'], agree: consent.agree }
      })
      agreement.agreementCustomFields = agreement.agreementCustomFields.map(customField => {
        if (customField['@id']) {
          return { customField: customField['@id'], value: customField.value }
        }
        return { customField: customField.customField, value: customField.value }
      })
      const response = await new ApiService('e_x_a_b_agreements').post(agreement)
      if (response.status < 300) commit('setCreated', await response.json())
      else commit('setViolations', response)
    }
  }
}
